import { Component, OnDestroy, OnInit } from "@angular/core";
import { AppVersionService } from "@main/app-versioning/api/app-version.service";
import { UserService } from "@main/users";

@Component({
    selector: "app-auto-update",
    templateUrl: "./app-auto-update.component.html",
    styleUrls: ["./app-auto-update.component.scss"]
})
export class AppAutoUpdateComponent implements OnInit, OnDestroy {
    private readonly autoUpdateReloadSeconds: number = 30;

    protected autoUpdateRemainingSeconds: number = 0;

    private intervalReference: NodeJS.Timeout;

    constructor(private appVersionService: AppVersionService,
                private userService: UserService) {
    }

    get updateAvailable(): boolean {
        return this.autoUpdateRemainingSeconds > 0;
    }

    set updateAvailable(value: boolean) {
        this.autoUpdateRemainingSeconds = value ? this.autoUpdateReloadSeconds : 0;
    }

    public ngOnInit(): void {
        this.appVersionService.versionChanges.subscribe(() => this.handleVersionChange());
    }

    public ngOnDestroy(): void {
        if (!!this.intervalReference) clearInterval(this.intervalReference);
    }

    protected applyUpdate(): void {
        this.resetCounter();
        this.appVersionService.updateVersion().then();
    }

    protected cancelUpdate(): void {
        this.resetCounter();
        this.appVersionService.cancelPendingUpdate();
    }

    private handleVersionChange(): void {
        if (this.userService.isLogged) {
            this.startAutoUpdateCounter();
        } else this.applyUpdate();
    }

    private startAutoUpdateCounter(): void {
        if (!!this.intervalReference) clearInterval(this.intervalReference);
        this.updateAvailable = true;
        this.intervalReference = setInterval(() => this.decreaseCounter(), 1000);
    }

    private decreaseCounter(): void {
        this.autoUpdateRemainingSeconds--;
        if (this.autoUpdateRemainingSeconds === 0) this.applyUpdate();
    }

    private resetCounter(): void {
        if (!!this.intervalReference) clearInterval(this.intervalReference);
        this.updateAvailable = false;
    }
}
